import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
export function ButtonPanel() {
  const { t } = useTranslation();
  return (
    <Box sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1200, bgcolor: 'white', p: 2, pb: 'max(16px, env(safe-area-inset-bottom))', maxWidth: '100%', }} >
      <Button
        disabled
        fullWidth
        variant="contained"
        sx={{ gap: 1, height: 42, borderRadius: '8px', bgcolor: 'rgba(0, 0, 0, 0.12)', color: 'rgba(0, 0, 0, 0.38)', fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 15, letterSpacing: '0.46px', textTransform: 'none', boxShadow: 'none', '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.12)', boxShadow: 'none', }, '&.Mui-disabled': { bgcolor: 'rgba(0, 0, 0, 0.12)', color: 'rgba(0, 0, 0, 0.38)', }, }}
      >
        {t('verify')}
      </Button>
    </Box>
  );
}
